
const APP_VERSION = '1.0.0';
const APP_NAME = process.env.VUE_APP_NAME === 'kujiflip' ? '賞翻天一番賞管理系統': '太和選賞管理系統';
// PRD

const API_URL = process.env.VUE_APP_API;

const headers = {
    'Content-Type': 'application/json',
};

const HTTP_METHODS = {
    GET : 'GET',
    POST : 'POST',
    DELETE : 'DELETE',
};

const TOKEN_KEY = process.env.VUE_APP_NAME === 'kujiflip' ? 'kuji_admin_token': 'taiwa_admin_token';
const LOGIN_USER =  process.env.VUE_APP_NAME === 'kujiflip' ? 'kuji_admin_login_user': 'taiwa_admin_login_user';


export {
    APP_VERSION,
    APP_NAME,
    API_URL,
    HTTP_METHODS,
    headers,
    TOKEN_KEY,
    LOGIN_USER,
}
